export default __webpack_public_path__ + "static/media/TynkerJr.8e892439.webp";